export default __webpack_public_path__ + "static/process-7e3140653873a1cf786879e48f9cc460.svg";